module.exports = {
      id: "pin-usage",
      viewBox: "0 0 9 11.1",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#pin-usage",
      toString: function () {
        return this.url;
      }
    }